import React from 'react';

// FilterChips - "Showing: Overdue Greasing ✕" above a list (LIST-03). A list reached through a
// link that filters it (a count link, a Dashboard tile) says so here, and each chip's ✕ clears
// its filter. Renders nothing when there are no chips.

export interface FilterChip {
  key: string;
  /** What the filter shows, Title Case ("Overdue Greasing", "SA16"). */
  label: string;
  onClear: () => void;
}

export interface FilterChipsProps {
  chips: FilterChip[];
  /** Text before the chips. */
  prefix?: string;
  className?: string;
  'data-testid'?: string;
}

export const FilterChips: React.FC<FilterChipsProps> = ({ chips, prefix = 'Showing:', className = '', ...rest }) => {
  if (chips.length === 0) return null;
  return (
    <div
      className={`tw-mb-3 tw-flex tw-flex-wrap tw-items-center tw-gap-2 ${className}`}
      data-testid={rest['data-testid'] ?? 'filter-chips'}
    >
      <span className="tw-text-sm tw-text-content-secondary">{prefix}</span>
      {chips.map((chip) => (
        <span
          key={chip.key}
          className="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-full tw-border tw-border-line-input tw-bg-surface tw-py-0.5 tw-pl-3 tw-pr-1 tw-text-sm"
        >
          {chip.label}
          <button
            type="button"
            onClick={chip.onClear}
            aria-label={`Clear ${chip.label} filter`}
            title={`Clear ${chip.label} filter`}
            className="tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-content-muted hover:tw-bg-surface-hover"
          >
            <i className="bi bi-x-lg" aria-hidden="true" />
          </button>
        </span>
      ))}
    </div>
  );
};

export default FilterChips;
